import React from 'react';

const BootcampTablePaginationFooter = ({ page, totalPages, onPageChange }) => (
  <div className="bootcamp-table-pagination">
    <button
      type="button"
      className="bootcamp-pagination-button"
      onClick={() => onPageChange(page - 1)}
      disabled={page <= 1}
    >
      Previous
    </button>
    <span className="bootcamp-table-pagination-meta">
      Page {page} of {totalPages}
    </span>
    <button
      type="button"
      className="bootcamp-pagination-button"
      onClick={() => onPageChange(page + 1)}
      disabled={page >= totalPages}
    >
      Next
    </button>
  </div>
);

export default BootcampTablePaginationFooter;
